import { Comment as CommentType } from '~/lib/discussions/types';
import { Button } from '@appsumo/dorado-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useComment } from '~/lib/discussions/useComment';
import { ReplyModal } from './ReplyModal';
import useUser from '~/lib/user';
import { useModal } from '@appsumo/dorado-react';
import { PDPContext } from '~/lib/product/context';
import { useContext } from 'react';
import type { Deal } from '~/types/deal';

export const Buttons = ({
  comment,
  mutateComment,
  isReview = false,
}: {
  comment: CommentType;
  mutateComment: () => void;
  isReview?: boolean;
}) => {
  const { deal }: { deal: Deal } = useContext(PDPContext);
  const { like } = useComment(comment, mutateComment);
  const { user } = useUser();
  const isEmailVerified = !!user?.email_verified;
  const isAuthenticated = !!user;
  const [showModal, hideModal] = useModal(
    () => (
      <ReplyModal
        deal={deal}
        hideModal={hideModal}
        comment={comment}
        type={isReview ? 'dealreview' : 'dealcomment'}
        mutateComment={mutateComment}
      />
    ),
    [],
  );

  return (
    <div className="mt-4 flex justify-end gap-x-2 max-sm:flex-col">
      <Button
        tertiary
        size="small"
        onClick={isEmailVerified ? like : void 0}
        disabled={!isEmailVerified}
      >
        <div className="flex items-center justify-center gap-x-1">
          <FontAwesomeIcon icon={faChevronUp} />
          <span>Helpful {comment.num_likes}</span>
        </div>
      </Button>
      {isAuthenticated && comment.level !== 2 && (
        <Button
          className="max-sm:mt-2"
          size="small"
          onClick={() => showModal()}
          disabled={!isEmailVerified}
        >
          Reply
        </Button>
      )}
    </div>
  );
};
